import { createSlice } from '@reduxjs/toolkit';

const managerSlice = createSlice({
  name: 'manager',
  initialState: {
    rows: [],
  },
  reducers: {
    replaceData(state, action) {
      state.rows = action.payload;
    },
  },
});

export const managerActions = managerSlice.actions;
export default managerSlice;
